import Busqueda from './Busqueda';
import {IoMdSearch} from 'react-icons/io';
export default {
  icon: IoMdSearch,
  list: Busqueda
};